import { CreateExportJobInput, ExportJob } from '@/API';
import { FilterDefinition } from '@lambda-layer/models/FilterDefinition/FilterDefinition.ts';
import { GenericService } from '@/service/GenericService.ts';
import { onUpdateExportJob } from '@/graphql/subscriptions.ts';
import { FilterSelections } from '@lambda-layer/types/filter.ts';
import { Subscription } from 'rxjs';

export type ListType = 'houselist' | 'boughtlist' | 'staffseed';

/**
 * Service for managing export jobs.
 */
export class ExportJobService extends GenericService<ExportJob> {
  async onUpdateEvent<T>(
    execute: (data: T) => void
  ): Promise<Subscription | undefined> {
    return await this.onEvent(execute, onUpdateExportJob);
  }

  async createExportJob(
    listType: ListType,
    exportName: string,
    filterDefinitions: FilterDefinition[],
    filterSelections: FilterSelections,
    reportId?: string,
    outputFormat: 'xlsx' | 'csv' = 'xlsx'
  ) {
    const exportJob = {
      listType,
      exportName,
      reportId,
      status: 'PENDING',
      outputFormat,
      filterInput: JSON.stringify(
        Object.fromEntries(
          Object.entries(filterSelections)
            .filter(
              ([, filterRowSelection]) => filterRowSelection.value.length > 0
            )
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            .map(([id, { externalUpdateHash, ...filterRowSelection }]) => {
              return [id, filterRowSelection];
            })
        )
      ),
      filterFields: JSON.stringify(
        FilterDefinition.simplify(filterDefinitions)
      ),
    } as CreateExportJobInput;

    return await this.repository.save(exportJob);
  }
}
